import { render, staticRenderFns } from "./HomeHotEvents.vue?vue&type=template&id=0e4bf082"
import script from "./HomeHotEvents.vue?vue&type=script&lang=js"
export * from "./HomeHotEvents.vue?vue&type=script&lang=js"
import style0 from "./HomeHotEvents.vue?vue&type=style&index=0&id=0e4bf082&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports